module.exports = __webpack_public_path__ + "static/media/LXGWWenKai-Bold.05d46267.ttf";